/**
 * ShaderBand — кинематографичная полоса-манифест с золотым GL-шейдером
 * (21st.dev «shader-animation») на фоне и editorial-строкой поверх.
 * Дышащий разворот между «кейсом» и «тарифами» + мягкий CTA к форме.
 */
import { useLang } from "../i18n";
import { useReveal } from "../lib/motion";
import { ShaderAnimation } from "./ShaderAnimation";

export function ShaderBand() {
  const { t } = useLang();
  const ref = useReveal<HTMLElement>();
  const b = t.band;

  return (
    <section
      ref={ref}
      className="relative isolate flex items-center justify-center overflow-hidden border-t border-b"
      style={{
        borderColor: "var(--line)",
        background: "var(--bg-deep)",
        minHeight: "clamp(420px, 52vh, 600px)",
      }}
    >
      <ShaderAnimation className="absolute inset-0 h-full w-full" />
      <div className="shader-scrim absolute inset-0" aria-hidden />

      <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-8">
        <p className="t-eyebrow reveal mb-6" data-reveal="">
          <b>{b.eyebrow}</b>
        </p>
        <h2
          className="t-serif-i reveal mb-6"
          data-reveal=""
          style={{ fontSize: "var(--text-display)", lineHeight: 1.05, color: "var(--fg)" }}
        >
          {b.line}
        </h2>
        <p
          className="reveal mx-auto mb-9 max-w-xl text-base sm:text-lg"
          data-reveal=""
          style={{ color: "var(--fg-soft)", "--reveal-delay": "120ms" } as React.CSSProperties}
        >
          {b.sub}
        </p>
        <div
          className="reveal"
          data-reveal=""
          style={{ "--reveal-delay": "200ms" } as React.CSSProperties}
        >
          <a href="#lead" className="btn-gold">
            {b.cta}
          </a>
        </div>
      </div>
    </section>
  );
}
